module.exports = __webpack_public_path__ + "static/media/NarrativeReel-500x250-Animated.d497cb76.mp4";